export default __webpack_public_path__ + "cacd6f3dd43fdf1b31597c26d0643190.png";